import React, {useState} from 'react';
import './App.css';
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Search from './components/Search/Search';
import Sidebar from './components/Sidebar/Sidebar';
function App() {
  const [bars, setBars] = useState(false)
  const [directSearch, setDirectSearch] = useState(false)

  return (
    <div className='app'>
      <div className='navbarComponent'>
        <Navbar 
        bars = {bars}
        setBars = {setBars}

        />
      </div>
      {bars===true?<div className='sidebarContainer showSideBar'>
        <Sidebar 
        setBars = {setBars}
        setDirectSearch = {setDirectSearch}
        />
      </div>:null}
      <div className='homeContainer'>
      <Home/>
      </div>
    <div className='searchContainer'>
    <Search
    setDirectSearch = {setDirectSearch}
    directSearch = {directSearch}
    />
    </div>

    </div>
  );
}

export default App;
